<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="loginArea">
        <v-system-bar color="primary" dark>
          <v-spacer></v-spacer>
          <v-icon
            v-show="confirmEmail"
            style="cursor: pointer"
            @click="resetLoginFrm"
            >cached</v-icon
          >
        </v-system-bar>
        <v-img
          :src="logo.src"
          class="white--text mx-5 mt-2"
          height="auto"
          :alt="logo.title"
        />
        <v-card-title class="justify-center" v-if="!clientList">
          <p color="primary" class="mt-2 mb-0 subheading" data-i18n>
            {{ logo.restrictedarea }}
          </p>
          <p class="mt-0 mb-0 mx-4 text-center subheading" data-i18n>
            {{ logo.txt }}
          </p>
        </v-card-title>
        <v-card-title class="justify-start" v-if="clientList">
          <p
            color="primary"
            class="mt-2 mb-1 mx-2 subheading font-weight-bold text-xs-left"
          >
            Você possui mais de uma conta
          </p>
          <p class="mt-0 mb-1 mx-2 text-xs-left body-2" data-i18n>
            Selecione na lista abaixo a conta que deseja acessar.
          </p>
        </v-card-title>
        <div v-if="clientList">
          <v-data-table
            id="loginUsersTable"
            hide-actions
            :headers="[]"
            hide-headers
            :items="accounts"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td
                style="cursor: pointer"
                @click="selectCompany(props.item)"
                class="text-xs-left"
              >
                <v-layout>
                  <v-flex xs1>
                    <v-icon v-if="!props.item.user_id">person</v-icon>
                    <v-icon v-if="props.item.user_id">apartment</v-icon>
                  </v-flex>
                  <v-flex xs11 class="pt-1 pl-2">
                    <!-- <span>Acessar como</span> -->
                    <b
                      class="grey--text text--darken-2"
                      style="font:size:15px"
                      >{{ props.item.name }}</b
                    >
                  </v-flex>
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </div>

        <v-card-text v-if="!clientList">
          <v-form ref="loginForm" v-model="validLoginForm" lazy-validation>
            <v-text-field
              v-show="!confirmEmail"
              prepend-icon="email"
              v-model="formData.email"
              name="email"
              label="E-mail"
              type="email"
              data-i18n="[label]"
              :rules="$store.state.formRules.emailRules"
              required
              v-on:keydown.enter.prevent="verifyUserMail"
            ></v-text-field>
            <v-text-field
              v-show="setPass"
              id="password"
              v-model="formData.password"
              prepend-icon="lock"
              name="password"
              label="Senha"
              type="password"
              data-i18n
              :rules="$store.state.formRules.required"
              required
              v-on:keydown.enter.prevent="verifyUserMail"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="text-center pr-3 pl-3 pb-3 pt-3">
          <v-btn
            @click="resetLoginFrm"
            v-if="clientList"
            flat
            color="grey darken-2"
            >VOLTAR</v-btn
          >
          <v-btn
            v-if="!clientList"
            flat
            color="grey darken-2"
            to="/recuperarsenha"
            >ESQUECI A SENHA</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!clientList"
            color="primary"
            class="white--text"
            @click="verifyUserMail"
            :loading="loadingBt"
            :disabled="loadingBt"
            >Login</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { login as loginService, token as tokenService, email as emailService } from '@/services/auth'

export default {
  name: 'Login',

  props: {
    errors: String
  },

  data () {
    return {
      loadingBt: false,
      clientList: false,
      accounts: [],
      confirmEmail: false,
      setPass: false,
      formData: {
        user_id: null,
        email: null,
        password: null
      },
      logo: {
        restrictedarea: 'Área restrita',
        src: './img/logo.png',
        title: 'InSight Síndicos',
        txt: 'Preencha o campo abaixo para fazer login no sistema.'
      },
      validLoginForm: true,
      pwdRules: [(v) => !!v || 'A senha é obrigatória'],
      emailRules: [
        (v) => !!v || 'O e-mail é obrigatório',
        (v) => /.+@.+/.test(v) || 'E-mail inválido!'
      ]
    }
  },

  mounted () {
    if (this.errors) {
      let opts = {
        message: this.errors,
        type: 'error'
      }
      this.$store.commit('showAlert', opts)
    }
  },

  methods: {
    resetLoginFrm () {
      this.accounts = []
      this.setPass = false
      this.clientList = false
      this.confirmEmail = false
      this.formData.user_id = ''
    },

    selectCompany (item) {
      this.formData.user_id = item.id ? item.id : item.user_id
      this.setPass = true
      this.clientList = false
    },

    async verifyUserMail () {
      if (this.setPass) {
        this.login()
        return
      }

      this.loadingBt = true

      await emailService(this.formData).then((response) => {
        if (response.length < 1) {
          let opts = {
            message: 'Usuário não encontrado.',
            type: 'warning'
          }

          this.$store.commit('showAlert', opts)

          return
        }

        if (response.length > 1) {
          this.accounts = [...response]
          this.confirmEmail = true
          this.clientList = true
        } else {
          this.formData.user_id = response[0].id
            ? response[0].id
            : response[0].user_id
          this.formData.password = ''
          this.$refs.loginForm.resetValidation()
          this.confirmEmail = true
          this.setPass = true
        }
      }).catch(error => {
        console.log('Erro verificando email: ', error)
      })

      this.loadingBt = false
    },

    async login () {
      if (!this.$refs.loginForm.validate()) {
        return
      }

      this.$store.commit('showLoader', {
        circle: true
      })

      if (this.$refs.loginForm.validate()) {
        const response = await loginService(this.formData)

        this.$store.commit('updateUserLoged', response.user, {
          root: true
        })

        localStorage.setItem(
          'userData',
          JSON.stringify(response.user)
        )

        await this.getToken({
          grant_type: response.grant_type,
          client_id: response.client_id,
          client_secret: response.client_secret,
          username: response.user.id,
          password: this.formData.password,
          scope: '*'
        })
      }

      this.$store.commit('hideLoader')
    },

    async getToken (authorization) {
      const response = await tokenService(authorization)

      localStorage.setItem('token', response.access_token)

      localStorage.setItem(
        'expireToken',
        new Date().getTime() + 9 * 60 * 60000
      )

      this.$router.push('/')
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>

<style>
#loginUsersTable tr:first-child {
  border-top: 2px solid #eee;
}
.loginArea {
  max-width: 350px;
  margin: auto;
}
</style>
